<template>
    <div>
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <div no-body class="mb-1" style="width: 100%; position: relative;">
          <ul id="myUL" class="p-0" style="margin-left: 0px;">
            <TreeItem @estaAbiertoTratamiento="estaAbiertoTratamiento"  v-for="(item, index) in catalogoTratamientos" :key="index" :item="item" />
        </ul>
          </div>
    </div>
  </template>
  
    <script>
    import TreeItem from './TreeItem.vue';
  export default {
    name: "SelectTratamientos",
    components: {
      TreeItem,
    },
    props: {
      catalogoTratamientos: Array,
      idSeleccionado: {
          type: Number,
          default: null
        },
      
    },
    data() {
      return {
        version: process.env.VUE_APP_ENV_VERSION,
        debug: false,
        collapseOpen: false,
        catalogoTratamientosOrdenado: [],
        tratamientosConHijos: [],
        tratamientosOrganizados: null,
        tratamientoSeleccionado: null,
        auxiliarSeleccionado: 0
      };
    },
    mounted () {
      this.$root.$on('enviarTratamiento', async(data) => {
        this.seleccionarTratamiento(data)
        this.closeCollapse();
      })
    },
    validations: {},
    created() {
      this.debug = this.$localStorageService.getDebug();
        // this.organizarTratamientos();
    },
    watch: {},
    computed: {
    },
    methods: {
      limpiarTratamiento(){
        this.tratamientoSeleccionado = "";
        const tratamiento = null;
        this.$root.$emit('enviarTratamiento', tratamiento, this.idSeleccionado);
      },

      seleccionarTratamiento(data){
        this.tratamientoSeleccionado = data.nombre;
      },

      openCollapse() {
        this.collapseOpen = true;
      },
      closeCollapse(){
        this.collapseOpen = false;
      },
       
      buscarHijos(tratamiento) {
      const hijos = this.catalogoTratamientos.filter(
        t => t.idTratamientoPadre === tratamiento.idTratamientoNuevo
      );

      hijos.forEach(hijo => {
        hijo.tratamientosHijo = this.buscarHijos(hijo);
      });

      return hijos;
    },

    organizarTratamientos() {
      this.tratamientosOrganizados = this.catalogoTratamientos.filter(
        t => t.idTratamientoPadre === null
      );
      this.tratamientosOrganizados.forEach(tratamiento => {
        tratamiento.tratamientosHijo = this.buscarHijos(tratamiento);
      });
    },

      estaAbiertoTratamiento(item) {

        this.catalogoTratamientos.forEach(j => {
          if (j.idTratamientoNuevo == null && item.isOpen == false){
            this.catalogoTratamientos.shift();
          }
        })

        if (this.auxiliarSeleccionado !== item.idTratamientoNuevo) {
          this.auxiliarSeleccionado = item.idTratamientoNuevo;
          let abierto = this.catalogoTratamientos.find(ct => ct.isOpen === true);
          if (abierto) {
            abierto.isOpen = false

            if (abierto.subTratamientos != null && abierto.subTratamientos.length > 0) {
              let abiertoHijos = abierto.subTratamientos.find(ct => ct.isOpen === true);
              if (abiertoHijos) {
                abiertoHijos.isOpen = false
              }
            }

          }
        } else {
          let abierto = this.catalogoTratamientos.find(ct => ct.isOpen === true);
          if (abierto) {
            if (abierto.subTratamientos != null && abierto.subTratamientos.length > 0) {
              let abiertoHijos = abierto.subTratamientos.find(ct => ct.isOpen === true);
              if (abiertoHijos) {
                abiertoHijos.isOpen = false
              }
            }
          }
        }
      }
    },
  };
  </script>
  
  <style scoped>
 p {
  color: #6f6f6f;
}
.floating-collapse {
    border-radius: 5px;
    z-index: 1000; 
}
.barras {
    border-width: 1px;
    border-style: solid;
    border-color: #d1d0d0;
    background: #ffffff;
    margin-top: 20px;
    padding-right: 1%;
    padding-left: 1%;
    border-radius: 5px;
    text-align: left;
    align-items: center;
}

.scrollable-container-tratamientos {
    overflow-y: auto;
    max-height: 105px;
}
  </style>
  
